import characterq from '../assets/characters/Character-q.png';

export const mintCharacters = [
    { id: 1, character: characterq },
    { id: 2, character: characterq },
    { id: 3, character: characterq },
    { id: 4, character: characterq }
];
